import React from "react"
import { TableHeaderColumn } from "react-bootstrap-table"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../../lib/Authenticated"
import SingleSelectTable from "../../../fragments/SingleSelectTable"
import UIAvatar from "../../../fragments/UIAvatar"
import { connect } from "react-redux"
import CustomBreadCrumb from "../../../fragments/CustomBreadCrumb"
import { Col, Row } from "react-bootstrap"
import ClearFiltersButton from "../../../fragments/ClearFiltersButton"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../../redux/items/types"
import { CardType, formatCurrency, sortDate, sortNumber } from "../../../../lib/utils"
import InvestorPaymentCard from "./Card"
import InvestorLink from "../../../fragments/InvestorLink"
import { Link, browserHistory } from "react-router"

class ListInvestorPayments extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAdminOrAccountant = this.isAdmin || this.authenticated.isAccountant()

  state = {
    selectedRow: null,
    isSelected: false,
  }

  componentDidMount() {
    this.props.loadData()
  }

  doClearFilters = () => {
    this.refs.id.cleanFiltered()
    this.refs.investorName.cleanFiltered()
    this.refs.currencyCode.cleanFiltered()
    this.refs.amount.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  itemSelected = (selectedRow, isSelected) => this.setState({
    selectedRow,
    isSelected
  })

  getElementById = (id, data) => data.find(item => item.id === id)

  updateLink = id => `/financiers/investors/payments/${id}/update`

  detailsLink = id => `/financiers/investors/payments/${id}/detail`

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  renderUpdateLink = id => {

    if(!this.isAdmin) return null
    return (
      <Link to={ this.updateLink(id) } className="p-5">
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  renderTable = payments => (
    <SingleSelectTable
      items={ payments }
      addNewLabel="Pay Investor"
      addNewHandler={() => browserHistory.push('/financiers/investors/payments/new')}
      exportCSV={ this.isAdminOrAccountant }
      csvFileName='payments.csv'
      shouldRenderToolbar={ this.isAdminOrAccountant }
      itemSelected={ this.itemSelected }
    >
      <TableHeaderColumn
        dataField="id"
        isKey
        dataAlign="center"
        dataFormat={(_, { investorName }) => <UIAvatar name={ investorName } size={ 28 } />}
        csvHeader="Payment ID"
        width='48'
      />

      <TableHeaderColumn
        ref="id"
        dataField="id"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, { id }) => this.renderDetailLink(id, id)}
        csvHeader="ID"
        columnClassName="min-w-120"
      >
        Payment ID
      </TableHeaderColumn>

      <TableHeaderColumn
        ref="investorName"
        dataField="investorName"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, { investor: { id, name }}) => <InvestorLink id={ id } name={ name } />}
        csvHeader="Investor"
        columnClassName="min-w-120"
      >
        Investor
      </TableHeaderColumn>

      <TableHeaderColumn
        ref="currencyCode"
        dataField="currencyCode"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        csvHeader="Currency"
        columnClassName="min-w-120"
      >
        Currency
      </TableHeaderColumn>

      <TableHeaderColumn
        ref="amount"
        dataField="amount"
        dataSort
        sortFunc={(a, b, order) => sortNumber(a.amount, b.amount, order)}
        dataAlign="center"
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="Amount"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        Amount
      </TableHeaderColumn>

      <TableHeaderColumn
        ref="createdOnFormatted"
        dataField="createdOnFormatted"
        dataAlign="center"
        dataSort
        sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
        filter={{ type: "DateFilter", delay: 1000 }}
        csvHeader="Created On"
        columnClassName='text-xs'
        width="140"
      >
        Created On
      </TableHeaderColumn>

      <TableHeaderColumn
        dataAlign="center"
        width="80px"
        dataFormat={(_, { id }) =>
        <span className="flex-detail">
          { this.renderDetailLink(id, <FontAwesome name="eye" title='Details' />) }
          { this.renderUpdateLink(id) }
        </span>}
      />
    </SingleSelectTable>
  )

  render() {

    const { investorPayments, setInvestorPayment, removeInvestorPayment } = this.props,

    { selectedRow, isSelected } = this.state,

    payment = selectedRow ? this.getElementById(selectedRow.id, investorPayments) : null,

    meetCond = isSelected && !!payment,

    breadCrumbData = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/investors', title: 'Investors' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText='Payments' data={ breadCrumbData } />

        <Row>
          <Col md={ meetCond ? 8 : 12 }>
            <ClearFiltersButton onClick={ this.doClearFilters } />
            { this.renderTable(investorPayments) }
          </Col>

          { meetCond &&
            <Col md={4}>
              <InvestorPaymentCard
                investorPayment={ payment }
                setInvestorPayment={ setInvestorPayment }
                removeInvestorPayment={ removeInvestorPayment }
                cardType={ CardType.SMALL }
              />
            </Col>
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const investorPayments = DckSelectors.selectAllItems(state, ItemTypes.InvestorPayment)
  return { investorPayments }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.InvestorPayment)),
  setInvestorPayment: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.InvestorPayment, id, data)),
  removeInvestorPayment: id => dispatch(DckActionCreators.itemRemove(ItemTypes.InvestorPayment, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListInvestorPayments)



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/List.js